module.exports = __webpack_public_path__ + "img/camera_power.41ce1dc4.png";